/*
 * @Date: 2025-07-10 09:15:52
 */
import { post } from "@/utils/commonAxios";

/**
 * 获取首页的资讯列表
 * @returns
 */
export const getIndexNewsList = () =>
  post(
    "/news/getIndexOfficialWebsiteNewsList",
    { id: 1 },
    { baseURL: `${process.env.VUE_APP_BASE_API}-core` }
  );

/**
 * 获取资讯分类列表
 * @returns
 */
export const getNewsClassifyList = () =>
  post(
    "/news/getOfficialWebsiteNewsClassifyList",
    {},
    { baseURL: `${process.env.VUE_APP_BASE_API}-core` }
  );

/**
 * 根据资讯ID获取资讯详情
 * @param { String } id
 * @returns
 */
export const getNewsDetailsById = (id) =>
  post(
    "/news/getOfficialWebsiteNewsDetails",
    { id },
    { baseURL: `${process.env.VUE_APP_BASE_API}-core` }
  );

/**
 * 根据资讯分类获取资讯列表
 * @param { String } id
 * @returns
 */
export const getNewsListByClassify = (id) =>
  post(
    "/news/getOfficialWebsiteNewsList",
    { id },
    { baseURL: `${process.env.VUE_APP_BASE_API}-core` }
  );
